import { ROUTES } from '@/types/common';
import Link from 'next/link';
import TotalIcon from './TotalIcon';

const TotalDepartmentButton = () => {
  return (
    <Link href={ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path}>
      <a className='flex aspect-square flex-col items-center justify-center gap-[12px] overflow-visible'>
        <div className='flex h-full w-full items-center justify-center'>
          <div
            className='flex items-center justify-center rounded-[18px] bg-gray-20 sm:rounded-[25px]'
            style={{ padding: '20%' }}
          >
            <TotalIcon className='h-full w-full object-contain' />
          </div>
        </div>
        <span className='typography-ui-13m lg:typography-ui-15m text-gray-700'>전체보기</span>
      </a>
    </Link>
  );
};

export default TotalDepartmentButton;
